import { UpdateFrequency } from '@kanbu/schema/enums';

export const UPDATE_FREQUENCY_OPTIONS = Object.values(UpdateFrequency);
